// Normalize the various shapes a Firestore timestamp can arrive in
// (Timestamp instance, Date, ISO string, or null/undefined) to milliseconds
// since the epoch. Missing or unparseable values return 0, which callers
// can safely compare with `>` / `<` without extra null-checks.
export const timestampToMillis = (value: unknown): number => {
  if (!value) return 0;
  if (
    typeof value === "object" &&
    value !== null &&
    typeof (value as { toMillis?: () => number }).toMillis === "function"
  ) {
    return (value as { toMillis: () => number }).toMillis();
  }
  if (value instanceof Date) return value.getTime();
  if (typeof value === "string") {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};
